<template>
    <div>
        <HeaderBox index="2"></HeaderBox>
        <div class="split"></div>
        <section>
            <article class="fl">
                <JottingList title="心随笔动"></JottingList>
            </article>
            <AsideBox></AsideBox>
        </section>
        <FooterBox></FooterBox>
    </div>
</template>

<script>
import HeaderBox from '../components/HeaderBox'
import JottingList from '../components/JottingList'
import AsideBox from '../components/AsideBox'
import FooterBox from '../components/FooterBox'
export default {
    components: {HeaderBox,JottingList,AsideBox,FooterBox}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/JottingView.vue